import styled from 'styled-components'

export const InfoBlock = styled.div`
  margin-bottom: 24px;
`

export const InfoLabel = styled.div`
  font-size: 13px;
  color: #8c8c8c;
  margin-bottom: 4px;
`

export const InfoValue = styled.div`
  font-size: 14px;
  color: #262626;
  font-weight: 500;
`

export const TagUser = styled.div`
  display: inline-block;
  padding: 2px 10px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  color: #1890ff;
  font-size: 13px;
`

export const TabsWrapper = styled.div`
  background: transparent;
  padding: 0;
  margin-top: 24px;
  
  .ant-tabs-nav {
    padding: 0 0px;
    margin-bottom: 0;
  }
  
  .ant-tabs-nav::before {
    border-bottom: 1px solid #f0f0f0;
  }
  
  .ant-tabs-tab {
    font-weight: 500;
  }
`

export const CreateSubTaskUploadFileListWrapperStyled = styled.ul`
  margin: 10px 0 0;
  padding-left: 0 !important;
  height: auto !important;
  overflow: hidden !important;
`

export const CreateSubTaskUploadFileListItemStyled = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  transition: all ease 0.3s;
  padding: 3px 0;
  border-bottom: 1px solid #ebebeb;

  &:hover {
    background-color: #ebebeb;
    transition: all ease 0.3s;

    .anticon-check,
    .anticon-delete {
      opacity: 1;
      visibility: visible;
      transition: all ease 0.3s;
    }
  }
`

export const SubWorkListItemStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid #e3e8ef;
  background-color: #fff;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  & > div:first-child {
    margin-right: auto;
    p {
      margin-bottom: 2px;
      font-weight: 500;
      font-size: 14px;
      color: black;
    }
    span {
      color: #bfbfbf;
      font-size: 12px;
    }
  }
`
